// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-primitives-Stars-style__container--Cl62a","stars":"packages-primitives-Stars-style__stars--Sylbf"};